import Axios from 'axios'
import VueCookie from 'vue-cookie'
import Util from './util.js'
import Config from '../conf'
import Qs from 'qs'

let Poll = (url) => {
  let data = {}
  return {
    has () {
      return data[url] || false
    },
    add () {
      data[url] = url
    },
    remove () {
      data[url] = false
    }
  }
}

let getFun = (path, data = {}) => {
  var url = Config.root + path
  var params = JSON.parse(JSON.stringify(data))
  if (VueCookie.get(Config['token_key'])) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookie.get(Config['token_key'])
    // params['token'] = encodeURIComponent(VueCookie.get(Config['token_key']))
  }
  return Axios.get(url + '?' + Util.serialize(params))
}

let postFun = (path, data = {}) => {
  var url = Config.root + path
  var params = JSON.parse(JSON.stringify(data))
  if (VueCookie.get(Config['token_key'])) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookie.get(Config['token_key'])
    // params['token'] = encodeURIComponent(VueCookie.get(Config['token_key']))
  }
  return Axios.post(url, Qs.stringify(params))
}

export default class Http {
  static get (url, params) {
    return new Promise((resolve) => {
      // console.log(reject)
      let poll = Poll(url)
      if (!poll.has()) {
        poll.add()
        getFun(url, params).then((res) => {
          resolve(res['data'])
          poll.remove()
        })
      }
    })
  }
  static post (url, params) {
    return new Promise((resolve) => {
      // console.log(reject)
      let poll = Poll(url)
      if (!poll.has()) {
        poll.add()
        postFun(url, params).then((res) => {
          resolve(res['data'])
          poll.remove()
        })
      }
    })
  }
}
